/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State, DocumentTitleContainerProps } from '../utils.tsx';
import { setTitle } from './set-title/index.tsx';
import { addDocumentTitle } from './add-document-title/index.tsx';
import { removeDocumentTitle } from './remove-document-title/index.tsx';
import { updateTitle } from './update-title/index.tsx';

export const actions: {
	setTitle: (title: string) => Action<State, DocumentTitleContainerProps>;
	addDocumentTitle: (symbol: symbol, title?: string) => Action<State>;
	removeDocumentTitle: (titleSymbol: symbol) => Action<State>;
	updateTitle: (title: string, context: symbol) => Action<State, DocumentTitleContainerProps>;
} = {
	setTitle,
	addDocumentTitle,
	removeDocumentTitle,
	updateTitle,
};
